<a *transloco="let t" [routerLink]="detailsUrl()" class="item">
  <div class="container-fluid">
    <div class="row align-items-center">
      <div class="col">
        @if (showState() || isDraft()) {
          <div class="row text-danger fst-italic">
            <div class="col-12">
              <app-activity-state-badge [state]="item().state" [verbose]="true"></app-activity-state-badge>
            </div>
          </div>
        }
        <div class="row">
          <div class="col-12">
            <h3 class="my-0 title"><app-activity-type-icon [type]="item().type"></app-activity-type-icon> {{ item().title ?? t('activity.item.Untitled') }}</h3>
          </div>
        </div>
        <div class="row tags">
          <div class="col-12">
            @for (tag of item().activities; track tag) {
              <span class="badge tag me-1">{{ tag }}</span>
            }
          </div>
        </div>
        <div class="row justify-content-between">
          @if (showHost()) {
            <div class="col-12 host">
              par {{ item()?.mainHost?.name }}
            </div>
          }
        </div>
        @if (nextSchedule()) {
          <div class="my-1">
            <app-schedule-preview
              [activity]="item()"
              [schedule]="nextSchedule()"
              [isPublic]="isPublic()">

            </app-schedule-preview>
            <!--        <app-schedule-details-->
            <!--          [activity]="item()"-->
            <!--          [schedule]="nextSchedule()">-->
            <!--        </app-schedule-details>-->
            @if (additionalSchedulesString()) {
              <span class="opacity-50">{{ additionalSchedulesString() }}</span>
            }
          </div>
        }
      </div>
      <div class="col-auto">
        <lucide-icon [img]="icons.rightChevron" [size]="30"></lucide-icon>
      </div>
    </div>
  </div>
</a>
